// removed by extract-text-webpack-plugin
module.exports = {"background":"_3IKsLiVikrdw_1gy8WQjfZ","shadow300":"_2tgf-B7wOgteZ7m4CVQTVO","shadow400":"_20h33Hmjlv8nnp1woBLJ4b","shadow600":"_3sI78Gm42pusy8Eq5kXP4c","shadow800":"_1yzo2xlRDat8qJUONinjHB"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/CoverImage/style.css
// module id = 415
// module chunks = 38